<template>
	
  <DataView :value="parameters" :layout="'grid'" :rows="8" class="data-grid-parameters"
                :paginator="false" paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
                currentPageReportTemplate="{currentPage} / {totalPages}"
    >

    <template #empty>
      <div class="p-m-4">-</div>
    </template>

    <template #grid="slotProps">
      <div v-if="slotProps.data.type==='sanigen'" class="p-col-12 p-md-6 nested-grid data-grid-parameter" >
        <Sanigen :serialNumber="serialNumber" size="small"/>
      </div>
      <div v-else class="p-col-12 p-md-6 nested-grid data-grid-parameter" >
        <div :class="['p-grid', 'p-ai-center', {'gray': slotProps.data.disabled}, {'clickable': slotProps.data.click!=null}]"
           @click="slotProps.data.click">
          <div class="p-col-fixed p-text-center data-grid-parameter-icon">
            <i v-if="slotProps.data.icon.spinner" class="cycle-spinner cycle-spinner-spin">
              <span :class="slotProps.data.icon.class" :style="slotProps.data.icon.style"/>
            </i>
            <span v-else :class="slotProps.data.icon.class" :style="slotProps.data.icon.style"/>
          </div>
          <div class="p-col data-grid-parameter-text">
            <span>{{slotProps.data.text}}</span>
          </div>
          <div class="p-col-fixed p-text-center data-grid-parameter-value" :style="slotProps.data.valueDivStyle">
            <span>{{slotProps.data.value}}</span> 
          </div>
          <div class="param-cta">
            <i v-if="slotProps.data.click!=null" class="pi pi-chevron-right" />
          </div>
        </div>
      </div>
    </template>

  </DataView>

  <!--                    -->
  <!-- ERRORS and SUCCESS -->
  <!--                    -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.mya.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('details.mya.dialog_error')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('details.mya.dialog_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />


  <!--                      -->
  <!-- HUMIDITY TEMP DIALOG -->
  <!--                      -->
  <Dialog v-model:visible="dialog.editParameters" class="irinox-dialog-dark" :modal="true" 
      :closable="true" :dismissableMask="true" :draggable="false">
    
    <div class="irinox-dialog-dark-content">
      <div class="p-grid nested-grid p-jc-center controls">
        <div class="p-col">
          <Control v-model="setpoint.airTemp" icon="icon-air_temp" :isTemperature="true" :min="limits.cellSetTempMin" :max="limits.cellSetTempMax" />
        </div>
        <div class="p-col">
          <Control v-model="setpoint.coreTemp" icon="icon-core_temp" :isTemperature="true" :min="limits.coreProbeSetTempMin" :max="limits.coreProbeSetTempMax" />
        </div>
        <div class="p-col">
          <Control v-model="setpoint.fan" icon="icon-fan" :min="limits.evapFanSetSpeedMin" :max="limits.evapFanSetSpeedMax" />
        </div>
        <!-- <div class="p-col">
          <Control v-model="setpoint.phaseDuration" icon="icon-time" :isTime="true" :min="limits.phaseDurationSetMin" :max="limits.phaseDurationSetMax"/>
        </div> -->
      </div>
      <Button :label="$t('details.mya.editParameters_dialog_cancel_button')" @click="()=>{dialog.editParameters=!dialog.editParameters}" style="width: 150px"/>
      <Button :label="$t('details.mya.editParameters_dialog_ok_button')" class="p-button-secondary" @click="saveSetpoint" style="width: 150px"/>
    </div>

    <template #footer>
    </template>
  </Dialog>

</template>

<script>
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import Sanigen from '../Sanigen.vue';
import Control from '../Control.vue';
import cycles from "@/cycles";
import { mapGetters } from 'vuex';
import EventHubListenerService from '../../../service/EventHubListenerService';
import commands from "../../../../public/json/commands_mya.json"

export default {
    components: {
      IrinoxDialogDark,
      Control,
      Sanigen,
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          cycles: cycles,
          commands: commands,
          dialog: {
            error: false,
            blockingError: false,
            success: false,
            editParameters: false
          },
          setpoint: {
            airTemp: null,
            coreTemp: null,
            fan: null,
            phaseDuration: null
          },
          parameters: []
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          role: 'userdata/role',
          deviceTwin: 'appliances/deviceTwin',
          isCelsius: 'userdata/isCelsius',
        }),
        readOnlyMode: function() {
          return this.role.includes('INTERNAL') || this.role==='SERVICE_SALES';
        },
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        myaCycleRunning: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.cycleRunning && this.deviceTwin.status.cycleRunning === 1;
        },
        myaContinuousCycleRunning: function() {
          return this.myaCycleRunning && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.continuousCycle == 1;
        },
        myaMode: function() {
          return this.myaCycleRunning && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.controlType ? this.deviceTwin.status.controlType : null;
        },
        // myaAirTemp: function() {
        //   return !this.myaIsCore && this.appliance.status && this.appliance.status.TCell ? this.appliance.status.TCell : null;
        // },
        // myaCoreTemp: function() {
        //   return this.myaIsCore && this.appliance.status && this.appliance.status.operativeCoreTemperature ? this.appliance.status.operativeCoreTemperature : null;
        // },
        // myaIsCore: function() {
        //   return this.appliance.cycle && this.appliance.cycle.coreProbeCheck && this.appliance.cycle.coreProbeCheck==3;
        // },
        myaCoreProbe1: function() {
          return this.myaCycleRunning && this.appliance.status ? this.appliance.status.T1CoreProbe1 : null;
        },
        myaCoreProbe2: function() {
          return this.myaCycleRunning && this.appliance.status ? this.appliance.status.TCoreProbe2 : null;
        },
        myaCoreProbe3: function() {
          return this.myaCycleRunning && this.appliance.status ? this.appliance.status.TCoreProbe3 : null;
        },
        myaRemainingTime: function() {
          if(!this.myaContinuousCycleRunning) {
            try {
              let time = this.myaCycleRunning && this.appliance.cycle && this.appliance.cycle.cycleTimeLeft ? this.appliance.cycle.cycleTimeLeft / 60 : null;
              //time in minutes
              if(time) {
                var hours = Math.floor(time / 60);
                time = time - hours * 60;
                var minutes = Math.floor(time);
                return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
              }
            } catch(err) {
              return "N/A";
            }
          }
          return "--h:--m";
        },
        myaAirSetpoint: function() {
          return this.myaCycleRunning && this.deviceTwin && this.deviceTwin.status ? this.deviceTwin.status.cellSetTemp : null;
        },
        myaCoreSetpoint: function() {
          return this.myaCycleRunning && this.deviceTwin && this.deviceTwin.status ? this.deviceTwin.status.coreProbeSetTemp : null;
        },
        myaFanLevel: function() {
          return this.myaCycleRunning && this.deviceTwin && this.deviceTwin.status ? this.deviceTwin.status.evapFanSetSpeed : null;
        },
        myaCyclePhaseNumber: function() {
          return this.myaCycleRunning && this.appliance.cycle && this.appliance.cycle.cyclePhaseNumber!=null ? this.appliance.cycle.cyclePhaseNumber : null;
        },
        myaCycleTotalPhases: function() {
          return this.appliance.cycle.cycleTotalPhases;
        },
        myaRunningCycleId: function() {
          return this.appliance.cycle && this.appliance.cycle.runningCycleId!=null ? this.appliance.cycle.runningCycleId.replace(/.*_/g, '') : null;
        },
        myaDuration: function() {
          try {
            //phaseDurationSet is in seconds
            let time = this.myaCycleRunning && this.appliance.cycle &&  this.appliance.cycle.phaseDuration ? this.appliance.cycle.phaseDuration / 60 : null;
            //time in minutes
            if(time) {
              var hours = Math.floor(time / 60);
              time = time - hours * 60;
              var minutes = Math.floor(time);
              return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
            }
          } catch(err) {
            return "N/A";
          }
          return "--h:--m";
        },
        myaIconStyle: function() {
          let myaCycles = this.cycles.icons[this.appliance.gamma];
          let myaCycle = myaCycles[this.myaRunningCycleId];
          if(myaCycle!=null) {
            return 'background-color: #002445; '+
              'mask: url(\'assets/irinox/icons'+myaCycle.svg+'\') no-repeat 50% 50%; '+
              '-webkit-mask: url(\'assets/irinox/icons'+myaCycle.svg+'\') no-repeat 50% 50%; '+
              'height: 25px; width: 100%; display: block;';
          }
          return '';
        },
        isSetpointEditable: function() {
          return this.myaCycleRunning && this.appliance.cycle && this.appliance.cycle.functionRunning != null && this.appliance.cycle.functionRunning != 21 && this.appliance.cycle.functionRunning != 22 && !this.readOnlyMode;
        },
        limits: function() {
          try {
            let p = this.commands.cycles;
            if(p) {
              let lim = this.$functions.clone(p);
              if(lim.cellSetTempMin) {
                lim.cellSetTempMin*=10;
              }
              if(lim.cellSetTempMax) {
                lim.cellSetTempMax*=10;
              }
              if(lim.coreProbeSetTempMin) {
                lim.coreProbeSetTempMin*=10;
              }
              if(lim.coreProbeSetTempMax) {
                lim.coreProbeSetTempMax*=10;
              }
              return lim;
            }
          } catch(err) {
            console.warn("Error parsing commands " + err);
          }
          return {
              name: null,
              cellSetTempMin: null,
              cellSetTempMax: null,
              coreProbeSetTempMin: null,
              coreProbeSetTempMax: null,
              evapFanSetSpeedMin: null,
              evapFanSetSpeedMax: null,
              phaseDurationSetMin: null,
              phaseDurationSetMax: null
            };
        }
    },
    watch: {
      appliance: 'buildParameters',
      role: 'buildParameters',
      'deviceTwin.status': 'buildParameters',
    },
    created() {
      this.eventHubListenerService = new EventHubListenerService();
    },
    mounted() {
      this.buildParameters();
    },
    methods: {
      buildParameters() {
        this.parameters[0] = { type: "sanigen"};
        this.parameters[1] = {
          click: null,
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "",
            style: this.myaCycleRunning ? this.myaIconStyle : ""
          },
          text: this.myaCycleRunning ? this.$t('details.mya.cycle_running') : this.$t('mya.no_cycle_running'),
          value: this.myaCycleRunning && this.myaRunningCycleId!=null ? this.$t('mya.cycles.'+this.myaRunningCycleId) : "",
          valueDivStyle: "min-width: 50% !important;"
        }
        this.parameters[2] = {
          click: null, 
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_modes"
          },
          text: this.$t('details.mya.mode'),
          value: this.myaMode ? this.$t('details.mya.mode_'+this.myaMode) : "---",
        }
        this.parameters[3] = {
          click: null, 
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_probe"
          },
          text: this.$t('details.mya.core_probe_1'),
          value: this.myaCoreProbe1!=null ? this.$functions.temperature(this.myaCoreProbe1, this.isCelsius) + " " + this.unit : "---"
        }
        this.parameters[4] = {
          click: null, 
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_hourglass"
          },
          text: this.$t('details.mya.remaining_time'),
          value: this.myaRemainingTime!=null ? this.myaRemainingTime : "---"
        }
        this.parameters[5] = {
          click: null, 
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_probe"
          },
          text: this.$t('details.mya.core_probe_2'),
          value: this.myaCoreProbe2!=null ? this.$functions.temperature(this.myaCoreProbe2, this.isCelsius) + " " + this.unit : "---"
        }
        this.parameters[6] = {
          click: this.isSetpointEditable ? this.editSetpoint : null, 
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_air_temp"
          },
          text: this.$t('details.mya.air_temp'),
          value: this.myaAirSetpoint!=null ? this.$functions.temperature(this.myaAirSetpoint, this.isCelsius) + " " + this.unit : "---"
        }
        this.parameters[7] = {
          click: null, 
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_probe"
          },
          text: this.$t('details.mya.core_probe_3'),
          value: this.myaCoreProbe3!=null ? this.$functions.temperature(this.myaCoreProbe3, this.isCelsius) + " " + this.unit : "---"
        }
        this.parameters[8] = {
          click: this.isSetpointEditable ? this.editSetpoint : null, 
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_core_temp"
          },
          text: this.$t('details.mya.core_temp'),
          value: this.myaCoreSetpoint!=null ? this.$functions.temperature(this.myaCoreSetpoint, this.isCelsius) + " " + this.unit : "---"
        }
        this.parameters[9] = {
          click: this.isSetpointEditable ? this.editSetpoint : null,
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_fan"
          },
          text: this.$t('details.mya.fan_level'),
          value: this.myaFanLevel!=null ? this.myaFanLevel : "---"
        }
        this.parameters[10] = {
          click: null, 
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_continuous"
          },
          text: this.$t('details.mya.continuous_cycle'),
          value: this.myaContinuousCycleRunning ? this.$t('details.mya.continuous_cycle_on') : this.$t('details.mya.continuous_cycle_off')
        }
        this.parameters[11] = {
          click: null, 
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_clock"
          },
          text: this.$t('details.mya.working_phase'),
          value: this.myaCyclePhaseNumber!=null ? this.$t('details.mya.phase_'+this.myaCyclePhaseNumber) + " / " + this.myaCycleTotalPhases : " -/-",
        }
        this.parameters[12] = {
          click: null,
          disabled: !this.myaCycleRunning,
          icon: {
            spinner: false,
            class: "icon-mya_clock"
          },
          text: this.$t('details.mya.phase_duration'),
          value: this.myaCycleRunning ? this.myaDuration : "---"
        }
      },
      editSetpoint() {
        this.setpoint.airTemp = this.myaAirSetpoint;
        this.setpoint.coreTemp = this.myaCoreSetpoint;
        this.setpoint.fan = this.myaFanLevel;
        this.setpoint.phaseDuration = this.appliance.cycle.phaseDuration / 60;
        this.dialog.editParameters = true;
      },
      saveSetpoint() {
        let data = {};
        if(this.setpoint.airTemp != null) {
          data.cellSetTemp = this.setpoint.airTemp;
        }
        if(this.setpoint.coreTemp != null) {
          data.coreProbeSetTemp = this.setpoint.coreTemp;
        }
        if(this.setpoint.fan != null) {
          data.evapFanSetSpeed = this.setpoint.fan;
        }
        // if(this.setpoint.phaseDuration != null) {
        //   data.phaseDurationSet = this.setpoint.phaseDuration;
        // }
        // data.phase = this.myaCyclePhaseNumber;

        this.dialog.editParameters = false;
        this.eventHubListenerService.postSetSetpoint(this.personaltoken, this.serialNumber, data)
          .then((response) => {
            if(response.code=="200") {
              this.dialog.success = true;
              let dt = this.$functions.clone(this.deviceTwin);
              if(data.cellSetTemp!=null) {
                dt.status.cellSetTemp = data.cellSetTemp;
              }
              if(data.coreProbeSetTemp!=null) {
                dt.status.coreProbeSetTemp = data.coreProbeSetTemp;
              }
              if(data.evapFanSetSpeed!=null) {
                dt.status.evapFanSetSpeed = data.evapFanSetSpeed;
              }
              // if(data.time!=null) {
              //   dt.status.phaseDurationSet = data.phaseDurationSet;
              // }
              this.$store.commit('appliances/deviceTwin', dt);
            } else {
              console.error("EXCEPTION "+JSON.stringify(response));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      }
  }
}
</script>

<style >

</style>